/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectCategoryComponent } from './select-category.component';
import { SysqueSelectBoxModule } from '../../../../../../shared/ui/src/lib/components/sysque-select-box';

@NgModule({
  declarations: [SelectCategoryComponent],
  imports: [CommonModule, SysqueSelectBoxModule],
  exports: [SelectCategoryComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SelectCategoryModule {}
